<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(numeriSim)="row">
                        <div v-if="row.item.numeriSim && row.item.numeriSim.length">
                            <span v-for="(sim, index) in row.item.numeriSim" :key="index"> {{ sim }}<span v-if="index < row.item.numeriSim.length - 1">, </span> </span>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Device" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-if="!row.item.fisso" v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Device" @click="onDelete(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Associa Sim" @click="onAssociaSim(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="sim-card" />
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Associa Operatore" @click="onAssociaOperatore(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="user" />
                            </b-button>
                            <!-- {{ row.item.id }} -->
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <configurazione-device-device-modal-edit-component ref="deviceModal" @afterSave="onAfterSaveModal" />
        <configurazione-device-associa-sim-modal-component ref="associaSimModal" @afterSave="onAfterSaveModal" />
        <configurazione-device-associa-operatore-modal-component ref="associaOperatoreModal" @afterSave="onAfterSaveModal" />
    </div>
</template>
<script>
import ConfigurazioneDeviceAssociaSimModalComponent from "./ConfigurazioneDeviceAssociaSimModalComponent.vue";
import ConfigurazioneDeviceAssociaOperatoreModalComponent from "./ConfigurazioneDeviceAssociaOperatoreModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioneDeviceDeviceModalEditComponent from "./ConfigurazioneDeviceDeviceModalEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { ConfigurazioneDeviceDeviceModalEditComponent, ConfigurazioneDeviceAssociaSimModalComponent, ConfigurazioneDeviceAssociaOperatoreModalComponent },
    data() {
        return {
            filtroConfigurazioneDevice: {},
            pathResource: "/devicedevice",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Tipo", key: "tipo", sortable: true },
                { label: "Sistema operativo", key: "sistemaOperativo", sortable: true },
                { label: "Imei", key: "imeii", thStyle: "width: 15rem" },
                { label: "Proprietario", key: "proprietario", sortable: true },
                { label: "Sim associata", key: "numeriSim", sortable: true },

                {
                    label: "Stato attuale",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneDevice = sessionStorage.getItem("filtroConfigurazioneDevice");
            if (filtroConfigurazioneDevice) {
                me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioneDevice, me.loadDataDeviceSuccess, me.loadDataDeviceError);
        },
        loadDataDeviceSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            console.log("Device caricati:", me.items);
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataDeviceError(error) {
            let me = this;
            console.log("Errore nel caricamento dei device:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneDevice = sessionStorage.getItem("filtroConfigurazioneDevice");
            if (filtroConfigurazioneDevice) {
                me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
            }
            me.loadData(me.filtroConfigurazioneDevice);
        },
        onEdit(item) {
            this.$refs.deviceModal.show(item);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questo device: " + item.tipo, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteDevice(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteDevice(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.deleteDeviceSuccess, me.deleteDeviceError);
        },
        deleteDeviceSuccess() {
            let me = this;
            me.$bvModal.msgBoxOk("Device eliminato con successo.", {
                title: "Eliminazione completata",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            me.loadData();
        },
        deleteDeviceError() {
            let me = this;
            me.$bvModal.msgBoxOk("Errore durante l'eliminazione del device.", {
                title: "Errore",
                size: "sm",
                okVariant: "danger",
                centered: true,
            });
        },
        onAfterSaveModal() {
            let me = this;
            me.loadData();
        },
        onAssociaSim(item) {
            let me = this;
            me.$refs.associaSimModal.init(item.id);
        },
        onAssociaOperatore(item) {
            let me = this;
            me.$refs.associaOperatoreModal.init(item.id);
        },
    },
};
</script>
